import { Badge } from '@/components/common/badge'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/common/table'
import { TabsContent } from '@/components/common/tabs'
import type { TransactionsContext } from '@/queries/transactionsContext.query'
import type { StepData } from '@/types/transactionsContext'
import type { Vault } from '@/types/vault'
import { formatTokenValue } from '@vaultsfyi/common/utils'
import { useMemo } from 'react'
import { z } from 'zod'

const claimDataSchema = z.object({
  assetAmount: z.string(),
  lpTokenAmount: z.string(),
})

export function SyrupWaitForRedeemTab({
  stepData,
  vault,
  transactionsContext,
}: {
  stepData: StepData
  vault: Vault
  transactionsContext: TransactionsContext
}) {
  const claimData = useMemo(() => {
    return claimDataSchema.parse((transactionsContext?.vaultSpecificData as Record<string, any>)['claimData'])
  }, [transactionsContext])

  return (
    <TabsContent value={stepData.name} className="mt-3 flex flex-col gap-3 md:mt-4 md:gap-4">
      {claimData && (
        <Table>
          <TableHeader>
            <TableRow variant="header">
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                {formatTokenValue(
                  { value: claimData.assetAmount, decimals: vault.asset.decimals },
                  { minimumFractionDigits: 2 }
                )}{' '}
                {vault.asset.symbol}
              </TableCell>
              <TableCell>
                <Badge color={'orange'}>Pending</Badge>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      )}
      <div className="flex flex-col gap-2 text-center">
        <p className="bold font-bold text-heading-foreground text-m">Withdrawal in progress...</p>
        <div className="text-gray-500 text-sm">
          Withdrawals are processed on a first-in, first-out basis as liquidity becomes available. The assets are sent
          directly to the Lenders wallet(s), not requiring them to execute another transaction. Most withdrawals are
          processed in under 24 hours, but could take up to 30 days. You'll be able to request another withdrawal once
          this one is complete.
        </div>
      </div>
    </TabsContent>
  )
}
